/** Identidade de persistência para visitante não autenticado (por navegador). */
export const FEATURE_TOUR_ANON_ID = 'anon';

/**
 * userId para localStorage de tours/hints.
 * Visitante (não logado ou user.id ausente/0 do estado inicial) usa `anon`.
 */
export function resolveFeatureTourUserId(store) {
  if (store?.getters?.getLogged) {
    const id = store.getters.getUser?.id;
    if (id != null && id !== 0 && id !== '') return id;
  }
  return FEATURE_TOUR_ANON_ID;
}
